module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-breakpoints-tab-content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n        Add a breakpoint\n        "), _c('div', {
    staticClass: "btn btn-primary sq pull-right",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("\n          Add\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bp-type"
    }
  }, [_vm._v("Breakpoint Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breakpointsPer),
      expression: "breakpointsPer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bp-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.breakpointsPer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.breakpoints), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.breakpointEntries), function(bp, i) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "shadow clearfix"
    }, [_c('hr', {
      staticClass: "hr-text",
      attrs: {
        "data-content": ("OPTION " + (i + 1))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'bp-min-' + i
      }
    }, [_vm._v("Minimum")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bp.minimumValue),
        expression: "bp.minimumValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "0.01",
        "id": 'bp-min-' + i
      },
      domProps: {
        "value": (bp.minimumValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(bp, "minimumValue", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'bp-max-' + i
      }
    }, [_vm._v("Maximum")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (bp.maximumValue),
        expression: "bp.maximumValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "0.01",
        "id": 'bp-max-' + i
      },
      domProps: {
        "value": (bp.maximumValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(bp, "maximumValue", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove(i)
        }
      }
    }, [_vm._v("\n                Delete\n              ")])])])])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a6184c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/Breakpoints.vue
// module id = 2138
// module chunks = 1